import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CalendarDaysIcon, DumbbellIcon, HomeIcon, ClipboardListIcon, SparklesIcon, UtensilsCrossedIcon, ImageIcon } from 'lucide-react';
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.08
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function IncludesSection() {
  return <section className="w-full px-5 py-20 md:py-28" style={{
    backgroundColor: 'var(--color-blush)'
  }} data-id="element-90">
      <motion.div className="max-w-[800px] mx-auto" initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={sectionVariants} data-id="element-91">
        <motion.h2 variants={childVariants} className="text-3xl md:text-4xl mb-4" style={{
        color: 'var(--color-slate)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-92">
          ¿Qué incluye exactamente?
        </motion.h2>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-12" style={{
        color: 'var(--color-slate)',
        opacity: 0.7
      }} data-id="element-93">
          Todo lo que necesitas en un solo PDF descargable.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-94">
          {/* Item 1 */}
          <motion.div variants={childVariants} className="flex items-start gap-4 rounded-xl p-5" style={{
          backgroundColor: 'var(--color-white)'
        }} data-id="element-95">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(168, 181, 160, 0.15)'
          }} data-id="element-96">
              <CalendarDaysIcon className="w-5 h-5" style={{
              color: 'var(--color-sage)'
            }} data-id="element-97" />
            </div>
            <div data-id="element-98">
              <p className="text-base md:text-lg font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-99">
                Plan 21 días
              </p>
              <p className="text-sm md:text-base" style={{
              color: 'var(--color-slate)',
              opacity: 0.6
            }} data-id="element-100">
                Bloques A/B/C organizados día por día
              </p>
            </div>
          </motion.div>

          {/* Item 2 */}
          <motion.div variants={childVariants} className="flex items-start gap-4 rounded-xl p-5" style={{
          backgroundColor: 'var(--color-white)'
        }} data-id="element-101">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(168, 181, 160, 0.15)'
          }} data-id="element-102">
              <DumbbellIcon className="w-5 h-5" style={{
              color: 'var(--color-sage)'
            }} data-id="element-103" />
            </div>
            <div data-id="element-104">
              <p className="text-base md:text-lg font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-105">
                Biblioteca de 30 rutinas
              </p>
              <p className="text-sm md:text-base" style={{
              color: 'var(--color-slate)',
              opacity: 0.6
            }} data-id="element-106">
                De 10 minutos, con variantes por nivel de energía
              </p>
            </div>
          </motion.div>

          {/* Item 3 */}
          <motion.div variants={childVariants} className="flex items-start gap-4 rounded-xl p-5" style={{
          backgroundColor: 'var(--color-white)'
        }} data-id="element-107">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(168, 181, 160, 0.15)'
          }} data-id="element-108">
              <HomeIcon className="w-5 h-5" style={{
              color: 'var(--color-sage)'
            }} data-id="element-109" />
            </div>
            <div data-id="element-110">
              <p className="text-base md:text-lg font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-111">
                Versiones sin saltos
              </p>
              <p className="text-sm md:text-base" style={{
              color: 'var(--color-slate)',
              opacity: 0.6
            }} data-id="element-112">
                Apto departamento — sin molestar a nadie
              </p>
            </div>
          </motion.div>

          {/* Item 4 */}
          <motion.div variants={childVariants} className="flex items-start gap-4 rounded-xl p-5" style={{
          backgroundColor: 'var(--color-white)'
        }} data-id="element-113">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(168, 181, 160, 0.15)'
          }} data-id="element-114">
              <ClipboardListIcon className="w-5 h-5" style={{
              color: 'var(--color-sage)'
            }} data-id="element-115" />
            </div>
            <div data-id="element-116">
              <p className="text-base md:text-lg font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-117">
                Trackers imprimibles
              </p>
              <p className="text-sm md:text-base" style={{
              color: 'var(--color-slate)',
              opacity: 0.6
            }} data-id="element-118">
                Sin obsesión — solo para ver tu avance
              </p>
            </div>
          </motion.div>

          {/* Item 5 */}
          <motion.div variants={childVariants} className="flex items-start gap-4 rounded-xl p-5" style={{
          backgroundColor: 'var(--color-white)'
        }} data-id="element-119">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(196, 168, 130, 0.15)'
          }} data-id="element-120">
              <SparklesIcon className="w-5 h-5" style={{
              color: 'var(--color-tan)'
            }} data-id="element-121" />
            </div>
            <div data-id="element-122">
              <p className="text-base md:text-lg font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-123">
                "Movimiento escondido"
              </p>
              <p className="text-sm md:text-base" style={{
              color: 'var(--color-slate)',
              opacity: 0.6
            }} data-id="element-124">
                Micro-hábitos que suman sin pedir tiempo extra
              </p>
            </div>
          </motion.div>

          {/* Item 6 */}
          <motion.div variants={childVariants} className="flex items-start gap-4 rounded-xl p-5" style={{
          backgroundColor: 'var(--color-white)'
        }} data-id="element-125">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(196, 168, 130, 0.15)'
          }} data-id="element-126">
              <UtensilsCrossedIcon className="w-5 h-5" style={{
              color: 'var(--color-tan)'
            }} data-id="element-127" />
            </div>
            <div data-id="element-128">
              <p className="text-base md:text-lg font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-129">
                Guía "comida modo mamá"
              </p>
              <p className="text-sm md:text-base" style={{
              color: 'var(--color-slate)',
              opacity: 0.6
            }} data-id="element-130">
                Sin dieta rígida — alimentación real y sostenible
              </p>
            </div>
          </motion.div>

          {/* Item 7 */}
          <motion.div variants={childVariants} className="flex items-start gap-4 rounded-xl p-5 md:col-span-2 md:max-w-[calc(50%-0.625rem)]" style={{
          backgroundColor: 'var(--color-white)'
        }} data-id="element-131">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'rgba(168, 181, 160, 0.15)'
          }} data-id="element-132">
              <ImageIcon className="w-5 h-5" style={{
              color: 'var(--color-sage)'
            }} data-id="element-133" />
            </div>
            <div data-id="element-134">
              <p className="text-base md:text-lg font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-135">
                Ilustraciones simples
              </p>
              <p className="text-sm md:text-base" style={{
              color: 'var(--color-slate)',
              opacity: 0.6
            }} data-id="element-136">
                Para cada ejercicio — sin confusión
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}